import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { ICmsBannerProps } from './cms-banner.models';
import { useStyles } from './cms-banner.styles';

export interface WithLinkComponentProps {
  children: ReactElement;
  link?: string;
  className: string;
  onClick?: () => void;
}

const WithLink = ({ link, children, className, onClick }: WithLinkComponentProps): JSX.Element => {
  if (link) {
    return link.startsWith('pwa://')
      ? (
        <Link
          to={link.replace('pwa:/', '')}
          className={className}
          data-testid="banner"
          onClick={onClick}
        >
          {children}
        </Link>
      ) : (
        <a
          className={className}
          href={link}
          data-testid="banner"
          target="_blank"
          onClick={onClick}
        >
          {children}
        </a>
      );
  }

  return children;
};

export const CmsBannerView = ({ source, link, onClick }: ICmsBannerProps): JSX.Element => {
  const classes = useStyles();

  return (
    <WithLink
      link={link}
      className={classes.imageLink}
      onClick={onClick}
    >
      <img
        className={classes.image}
        src={source}
        alt=""
      />
    </WithLink>
  );
};
